"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormButtonLink = exports.FormButton = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Link = _interopRequireDefault(require("../Link"));
var _palette = require("../../styles/palette");
var _vars = require("../../styles/vars");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var FormButton = exports.FormButton = _styledComponents["default"].button.attrs({
  type: 'button'
}).withConfig({
  displayName: "styles__FormButton",
  componentId: "sc-tlxmwy-0"
})(["background:", ";border:1px solid transparent;border-radius:", ";color:#fff;cursor:pointer;display:block;font-family:inherit;font-size:14px;font-weight:bold;letter-spacing:1.25px;line-height:18px;outline:0;padding:11px 8px;text-align:center;text-decoration:none;text-transform:uppercase;width:100%;&:focus{box-shadow:0 0 0 2px rgba(0,0,0,0.2);position:relative;z-index:999;}&:disabled{opacity:0.5;pointer-events:none;}", ""], function (p) {
  return p.theme.buttonColor;
}, function (p) {
  return _vars.borderRadius[p.device];
}, function (p) {
  return p.isInverse && "\n    background: #fff;\n    border-color: ".concat(_palette.commonPalette.borderGrey, ";\n    color: ").concat(p.theme.buttonColor, ";\n    ");
});
var FormButtonLink = exports.FormButtonLink = FormButton.withComponent(_Link["default"]);
//# sourceMappingURL=styles.js.map